var render = function render(){var _vm=this,_c=_vm._self._c;return (
    false && this.$route.name === 'Kiosk' && _vm.getBreakpoints.includes('xxxl')
  )?_c('div',{staticClass:"d-flex h-100 position-absolute kioskOverlay flex-wrap"},_vm._l((_vm.panels),function(panel){return _c('div',{key:panel,staticClass:"border w-25 h-50 panel d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"panelNum"},[_vm._v(_vm._s(panel))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }